var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTickCircle = function SvgTickCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#174719"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.05c-5.49 0-9.95 4.47-9.95 9.95s4.46 9.95 9.95 9.95 9.95-4.46 9.95-9.95S17.48 2.05 12 2.05m0 18.39c-4.66 0-8.45-3.79-8.45-8.45S7.34 3.55 12 3.55s8.45 3.79 8.45 8.45-3.79 8.45-8.45 8.45z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.59a6.41 6.41 0 1 0 0 12.82 6.41 6.41 0 0 0 0-12.82m3.01 5.59-3.31 3.31c-.13.13-.31.21-.5.21s-.36-.07-.5-.21l-1.86-1.86a.706.706 0 0 1 0-.99c.27-.27.72-.27.99 0L11.19 13l2.82-2.82c.27-.27.72-.27.99 0s.27.72 0 .99z"
  })));
};
export default SvgTickCircle;